import { Component, computed, input } from '@angular/core';
import { Skeleton } from '@ntv360/component-pantry';

export type ThumbnailSkeletonSize = 'md' | 'lg' | 'content-grid';

interface ThumbnailSkeletonDimensions {
    previewHeight: string;
    previewRadius: string;
    titleHeight: string;
    isContentGrid: boolean;
}

@Component({
    selector: 'app-thumbnail-skeleton',
    imports: [Skeleton],
    templateUrl: './thumbnail-skeleton.component.html',
    styleUrl: './thumbnail-skeleton.component.scss',
})
export class ThumbnailSkeletonComponent {
    /** Number of skeletons to display for loading */
    public skeletonCount = input.required<number>();

    /**
     * Grid/layout variant for the skeleton grid.
     * `content-grid` matches media-library and single-playlist thumbnails (10 per row, 172px preview).
     */
    public skeletonSize = input<ThumbnailSkeletonSize>('md');

    /** Array of numbers to iterate over for skeleton display */
    protected skeletons = computed(() => Array.from({ length: this.skeletonCount() }));

    /** Computed dimensions for the thumbnail skeleton */
    protected dimensions = computed<ThumbnailSkeletonDimensions>(() => {
        if (this.skeletonSize() === 'content-grid') {
            return {
                previewHeight: '172px',
                previewRadius: '10px',
                titleHeight: '12px',
                isContentGrid: true,
            };
        }

        return {
            previewHeight: '140px',
            previewRadius: '8px',
            titleHeight: '14px',
            isContentGrid: false,
        };
    });
}
